import { connect } from 'react-redux'
import Security from '../../security'
import Layout from './Layout'
import * as selector from '../state/selector'
import { selectIsFetching } from '../state/selector'
import { selectLocationPath } from '../../router/selector'
import { selectUser } from '../../security/state/auth/selector'
import * as action from '../state/action'

const mapStateToProps = (state) => {
    return {
        isFetching: selectIsFetching(state),
        locationPath: selectLocationPath(state),
        user: selectUser(state),
        isNavigationCollapsed: selector.selectIsNavigationCollapsed(state),
    }
}

const mapDispatchToProps = {
    logout: Security.action.logout,
    toggleNavigation: action.toggleNavigation,
}

export default connect(mapStateToProps, mapDispatchToProps)(Layout)



// WEBPACK FOOTER //
// ./src/modules/layout/component/LayoutContainer.js